import React from 'react'

const IMG_API = "http://image.tmdb.org/t/p/w1280";

const moviePoster ='https://images.unsplash.com/photo-1485846234645-a62644f84728?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1340&q=80'

const setVoteClass = (vote)=>{
  if(vote >=8){
      return 'green'
  }else if(vote>=6){
      return 'orange'
  } else{
      return 'red'
  }
}

export default function Movie({title, poster_path, overview, vote_average}) {
    return (
        <div className='movie'>
            <img src={poster_path ? IMG_API + poster_path :moviePoster } alt={title} />
            <div className='movie-info' >
                <h3>{title}</h3>
                <span className={
                    `tag ${setVoteClass(vote_average)}`
                    }>
                     {vote_average}</span>
            </div>

            <div className='movie-over'>
                <h2>Overview:</h2>
                <p>{overview}</p>
            </div>
        </div>
    )
}


